import React from 'react'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import CharterBundleModalUspItem from './CharterBundleModalUspItem'
import LineLuxuryEscapesPlaneTailIcon from 'LuxKit/Icons/line/LineLuxuryEscapesPlaneTailIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'

type CharterLearnMoreUsp = React.ComponentProps<typeof CharterBundleModalUspItem>

export const MaldivesUspGroup1: Array<CharterLearnMoreUsp> = [
  {
    title: 'Save up to 20 hours in transit*',
    description: 'No more international stopovers and waiting in airports, fly non-stop from Melbourne to Malé.',
    icon: <LinePlaneDepartureIcon />,
    tabletIcon: <LinePlaneDepartureIcon size="XL" />,
  },
  {
    title: 'Maximise your holiday time',
    description: 'Our overnight flights paired with early check-in & late checkout give you extra time to enjoy the Maldives.',
    icon: <LineClockWithTickIcon />,
    tabletIcon: <LineClockWithTickIcon size="XL" />
  }
]
export const MaldivesUspGroup2: Array<CharterLearnMoreUsp> = [
  {
    title: 'Flexible bookings',
    description: 'Enjoy free cancellation within 7 days of purchase, and flexible date change options. Conditions apply.',
    icon: <LineCalendarCheckIcon />,
    tabletIcon: <LineCalendarCheckIcon size="XL" />,
  },
  {
    title: 'Luxury Escapes private charter',
    description: 'Weekly direct flights aboard a full-service Airbus A330-300, reserved exclusively for Luxury Escapes customers.',
    icon: <LineLuxuryEscapesPlaneTailIcon />,
    tabletIcon: <LineLuxuryEscapesPlaneTailIcon size="XL" />
  }
]
export const MaldivesUspMobile: Array<Partial<CharterLearnMoreUsp>> = [
  {
    title: 'Save up to 20 hours in transit*',
    description: 'Save up to 20 hours in transit*',
    icon: <LinePlaneDepartureIcon />,
  },
  {
    title: 'Maximise your holiday time',
    description: 'Maximise your holiday time with early check-in & late checkout',
    icon: <LineClockWithTickIcon />,
  },
  {
    title: 'Flexible bookings',
    description: 'Free cancellation within 7 days. Conditions apply.',
    icon: <LineCalendarCheckIcon />,
  },
  {
    title: 'Luxury Escapes private charter',
    description: 'Luxury Escapes private charter aboard a full service A330-300 aircraft.',
    icon: <LineLuxuryEscapesPlaneTailIcon />,
  }
]
